module.exports = __webpack_public_path__ + "static/taryn-5405c96957781cdc88c60a57b916f50d.jpg";